import { Outlet } from 'react-router-dom';

import { config } from '@/app/config/env';
import { MAIN_CONTENT_ID } from '@/components/shared/SkipToContent';

/**
 * Layout for unauthenticated pages.
 *
 * Deliberately free of navigation: a signed-out visitor has nowhere to go, and
 * showing app chrome they cannot use is misleading.
 */
export function AuthLayout() {
  return (
    <main
      id={MAIN_CONTENT_ID}
      tabIndex={-1}
      className="bg-muted/30 flex min-h-dvh flex-col items-center justify-center p-4 focus:outline-none sm:p-6"
    >
      <div className="w-full max-w-sm space-y-6">
        <div className="text-center">
          <h1 className="text-2xl font-semibold tracking-tight">{config.appName}</h1>
        </div>

        <Outlet />
      </div>
    </main>
  );
}
